import { render, staticRenderFns } from "./StockOrderViewModal.vue?vue&type=template&id=46acc6eb"
import script from "./StockOrderViewModal.vue?vue&type=script&lang=ts"
export * from "./StockOrderViewModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports